import React, { memo, useState } from "react";
import {
  Controller,
  FieldValues,
  RegisterOptions,
  useFormContext,
} from "react-hook-form";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { RedAsterisk } from "../../../styles/controls";
import BottomSheet from "../bottomSheet";
import MessageViewer from "../messageViewer";

export interface IOption {
  value: string;
  isEnabled: boolean;
}

export interface IMobileDropdown {
  label?: string;
  name: string;
  note?: string;
  options: string[] | IOption[];
  placeholder?: string;
  rules?:
    | Omit<
        RegisterOptions<FieldValues, string>,
        "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
      >
    | undefined;
  title: string;
}

function MobileDropdown({
  note,
  name,
  rules,
  label,
  placeholder,
  title,
  options,
}: IMobileDropdown) {
  const [open, setOpen] = useState(false);
  const {
    control,
    setValue,
    getValues,
    trigger,
    formState: { errors },
  } = useFormContext();

  const clickHandler = () => {
    setOpen(true);
  };
  const close = () => setOpen(false);

  const selection = (value: string) => {
    setValue(name, value, { shouldDirty: true });
    trigger(name);
    close();
  };
  return (
    <div>
      <InputLabel>
        {label}
        <RedAsterisk>&thinsp;*</RedAsterisk>
      </InputLabel>
      <FormControl fullWidth id={name}>
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field, fieldState: { error } }) => (
            <div>
              <Select
                {...field}
                open={false}
                onClick={clickHandler}
                error={error !== undefined}
                fullWidth
                displayEmpty
                renderValue={(value: any) => {
                  if (!value) {
                    return <Typography color="gray">{placeholder}</Typography>;
                  }
                  return value;
                }}
              >
                {options.map((item) => (
                  <MenuItem
                    key={typeof item === "string" ? item : item.value}
                    disabled={typeof item === "string" ? true : item.isEnabled}
                    value={typeof item === "string" ? item : item.value}
                  >
                    {typeof item === "string" ? item : item.value}
                  </MenuItem>
                ))}
              </Select>
            </div>
          )}
        />
        {errors[name] && (
          <MessageViewer
            status="error"
            details={String(errors[name]?.message)}
          />
        )}
      </FormControl>
      <BottomSheet
        list={options}
        open={open}
        title={title}
        onSelection={selection}
        selected={getValues(name)}
        onClose={close}
        note={note}
      />
    </div>
  );
}

export default memo(MobileDropdown);
